import storePlugin from './store';
import GlobalSnackbar from './GlobalSnackbar';
import * as constants from './constants';

const log = require('debug')('@mycure/vue-plugins/' + constants.NAMESPACE);

/**
 * @typedef {Object} PluginOpts
 * @property {string} namespace
 * @property {import('vuex').Store} store vuex store
 * @property {import('./store').StoreOpts} storeOpts
 * @property {boolean} injectComponents
 */

export default {
  /**
   * @param {import('vue').Component} Vue
   * @param {PluginOpts} [opts]
   */
  install (Vue, opts) {
    const { storeOpts, ...restOpts } = opts = Object.assign({ namespace: constants.NAMESPACE }, opts);
    log(`installing '${constants.NAMESPACE}' with opts'`, opts);

    // instal store module
    if (opts.store) Vue.use(storePlugin, { ...restOpts, ...storeOpts });

    // inject components
    if (opts.injectComponents) Vue.component('mc-global-snackbar', GlobalSnackbar);
  },
  namespace: constants.NAMESPACE
};
